import { gql, QueryHookOptions, TypedDocumentNode } from "@apollo/client";

import {
  GetCaseBlacklistedIdentifiersQuery,
  GetCaseBlacklistedIdentifiersQueryVariables,
} from "src/graphql/anti-fraud/__generated__/graphql";
import { blacklistedIdentifierFragment } from "src/graphql/anti-fraud/fragments/BlacklistedIdentifierFragment";
import { useFetchQuery } from "src/graphql/utils";
import { mapToBlacklistedCaseIdentifier } from "src/mappers/case.mappers.ts";
import { isEmpty } from "src/utils/arrays.utils.ts";

export const getCaseBlacklistedIdentifiersQuery = gql`
  query GetCaseBlacklistedIdentifiers($id: ID!) {
    case(id: $id) {
      blacklistedIdentifiers {
        ...BlacklistedIdentifierFragment
      }
    }
  }

  ${blacklistedIdentifierFragment}
` as TypedDocumentNode<
  GetCaseBlacklistedIdentifiersQuery,
  GetCaseBlacklistedIdentifiersQueryVariables
>;

export const useGetBlacklistedIdentifiers = (
  options?: QueryHookOptions<
    GetCaseBlacklistedIdentifiersQuery,
    GetCaseBlacklistedIdentifiersQueryVariables
  >
) =>
  useFetchQuery(getCaseBlacklistedIdentifiersQuery, {
    toData: (data) => data?.case?.blacklistedIdentifiers.map(mapToBlacklistedCaseIdentifier) ?? [],
    isEmpty: (data) => isEmpty(data?.case?.blacklistedIdentifiers),
    uiErrors: {
      fetchError: "FETCH-BLACKLIST-IDENTIFIERS-ERROR",
    },
    queryOptions: options,
  });
